<template>
  <v-list-item dense :class="[item.new ? 'newcolor' : '', item.changed ? 'changecolor' : '']" @click="$emit('click')">
    <v-list-item-icon class="my-auto mr-3">
      <v-icon v-text="'$repair_place'" size="18" />
    </v-list-item-icon>
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        {{ item.Description }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="item.new || item.changed">
      <v-card :color="item.new ? 'green' : 'orange'" dark class="px-2 rounded-pill" offset-x="0" :offset-y="10">
        {{ item.new ? $t('servicesystem.common_objects.commonterms.new') :
    $t('servicesystem.common_objects.commonterms.changed') }}
      </v-card>
    </v-list-item-action>
  </v-list-item>
</template>


<script>
export default {
  name: "RepairPlaceListItem",
  props: {
    item: Object,
  },
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>